import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   page: 0,
   dataCount: 0,
   offset: 0,
   dataPerPage: 15,
   sortField: "createdOn",
   sortType: "DESC",
   auditActionButtonClick: false,//
   auditEditActionTrigger: false
};

export const AuditSlice = createSlice({
   name: "audit",
   initialState: initialState,
   reducers: {
      setEditAuditTableReset: (state) => {
         state.page = 0;
         state.offset = 0;
      },
      setAuditActionButtonClick: (state, action) => {
         state.auditActionButtonClick = action.payload;
      },
      setAuditEditActionTrigger: (state, action) => {
         state.auditEditActionTrigger = action.payload;
      },
      setPageConfigData: (state, action) => {
         switch (action.payload.type) {
            case "SET_PAGE":
               state.page = action.payload.data;
               break;
            case "SET_DATA_COUNT":
               state.dataCount = action.payload.data;
               break;
            case "SET_IS_LOADING":
               state.isLoading = action.payload.data;
               break;
            case "SET_DATA_PER_PAGE":
               state.dataPerPage = action.payload.data;
               break;
            case "SET_OFFSET":
               state.offset = action.payload.data;
               break;
            default:
               break;
         }
      },
   },
});

export const auditActions = AuditSlice?.actions;
